import BaseEcharts from './src/base-eacharts.vue'

export default BaseEcharts
